module.exports = __webpack_public_path__ + "img/maps-marker-huis.34f33997.svg";